import {
    SET_MAINTENANCE_DATA,
    SET_CAUTIONS_DATA,
    SET_COMPONENTTRACKING_DATA,
    SET_COMPONENTTRACKING_FILTER,
    SET_SELECTEDMR_DATA
} from './types';


const reducers = (state: any = {}, action: any) => {

    switch (action.type) {
        case SET_MAINTENANCE_DATA: {
            return {
                ...state, ...action.maintenanceData
            };
        }
        case SET_CAUTIONS_DATA: {
            return {
                ...state, cautionsData:action.cautionsData
            };
        }
     
        case SET_COMPONENTTRACKING_DATA: {
            return {
                ...state,
                componentTrackingData: action.componentTrackingData
            };
        }
         case SET_COMPONENTTRACKING_FILTER: {
            return {
                ...state,
                ...action.componentTrackingfilter
            };
        }

        case SET_SELECTEDMR_DATA: {
            return {
                ...state,
                ...action.selectedMRdata
            };
        }

        default:
            return state;
    }
};

export default reducers;
